export const DEVICE_ID_STORAGE_KEY = 'hh_device_id';

const isClient = () => typeof window !== 'undefined';

export const getStoredDeviceId = () => {
  if (!isClient()) return null;
  return localStorage.getItem(DEVICE_ID_STORAGE_KEY);
};

export const getOrCreateDeviceId = () => {
  if (!isClient()) return null;

  let deviceId = getStoredDeviceId();
  if (deviceId) return deviceId;

  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    deviceId = crypto.randomUUID();
  } else {
    deviceId = `dev-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
  return deviceId;
};
